










import { Vue, Component, Prop } from "vue-property-decorator";

// TODO Improve days and Months
@Component
export default class DateClockComponent extends Vue {
  @Prop({ default: "dark" }) mode!: string;

  get dayOfWeek(): string {
    const days = [
      "Domingo",
      "Segunda Feira",
      "Terça Feira",
      "Quarta Feira",
      "Quinta Feira",
      "Sexta Feira",
      "Sábado"
    ];

    return days[new Date().getDay()];
  }

  get currentDate(): string {
    const date = new Date();
    const months = [
      "Janeiro",
      "Fevereiro",
      "Março",
      "Abril",
      "Maio",
      "Junho",
      "Julho",
      "Agosto",
      "Setembro",
      "Novembro",
      "Outubro",
      "Dezembro"
    ];

    return date.getDate() + " de " + months[date.getMonth()];
  }
}
